import React from 'react';
import { Dialog } from './common/Dialog';
import { Button } from './common/Button';
import * as styles from '../styles/components/mds-url-warning-dialog.css.ts';

interface MdsUrlWarningDialogProps {
  /** 警告の対象URL */
  url: string;
  /** 警告の理由 */
  reason: string;
  /** キャンセル時のコールバック */
  onCancel: () => void;
  /** 続行時のコールバック */
  onContinue: () => void;
}

/**
 * MDS URL読み込み時のセキュリティ警告ダイアログ
 * 信頼できないURLからのMDSファイル読み込み時に表示されます。
 */
export const MdsUrlWarningDialog: React.FC<MdsUrlWarningDialogProps> = ({
  url,
  reason,
  onCancel,
  onContinue
}) => {
  return (
    <Dialog
      isOpen={true}
      onClose={onCancel}
      title="URL Security Warning"
      width="md"
      closeOnOverlayClick={false}
      data-testid="mds-url-warning-dialog"
      footer={
        <>
          <Button variant="secondary" onClick={onCancel} data-testid="cancel-button">
            Cancel
          </Button>
          <Button variant="primary" onClick={onContinue} data-testid="continue-button">
            Continue Anyway
          </Button>
        </>
      }
    >
      <div>
        <div className={styles.warningIcon}>
          ⚠️
        </div>

        <p className={styles.message}>
          {reason}
        </p>

        <div className={styles.urlBox}>
          <div className={styles.urlLabel}>URL:</div>
          <div className={styles.urlText}>{url}</div>
        </div>

        <div className={styles.riskList}>
          <div className={styles.riskTitle}>Potential Risks:</div>
          <div className={styles.riskItem}>
            <span className={styles.riskBullet}>•</span>
            <span className={styles.riskText}>
              The server may log your IP address and browser information
            </span>
          </div>
          <div className={styles.riskItem}>
            <span className={styles.riskBullet}>•</span>
            <span className={styles.riskText}>
              The MDS file content may contain malicious data
            </span>
          </div>
          <div className={styles.riskItem}>
            <span className={styles.riskBullet}>•</span>
            <span className={styles.riskText}>
              Private network URLs may expose internal services
            </span>
          </div>
        </div>

        <div className={styles.note}>
          <strong>Recommendation:</strong> Only load MDS files from sources you control and trust.
        </div>
      </div>
    </Dialog>
  );
};
